import type { CropData } from "../../lib/utils";

export const sectionIds = [
  "general",
  "social",
  "discord",
  "invitations",
  "games",
  "members",
  "applications",
  "billing",
  "danger",
] as const;

export type SectionId = (typeof sectionIds)[number];

export type NavItem = {
  id: SectionId;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  danger?: boolean;
  ownerOnly?: boolean;
  adminOnly?: boolean;
};

export type Privacy = "public" | "invite_only" | "private";

export type { CropData } from "../../lib/utils";

export type ClubData = {
  id: string;
  name: string;
  description: string | null;
  privacy: Privacy;
  discordUrl: string | null;
  discordGuildId: string | null;
  discordCategoryId: string | null;
  disputeWebhookChannelId: string | null;
  discordChannelMode: "shared_category" | "per_match_category" | "none";
  discordModeratorRoleIds: string[] | null;
  twitterUrl: string | null;
  websiteUrl: string | null;
  youtubeUrl: string | null;
  facebookUrl: string | null;
  twitchUrl: string | null;
  instagramUrl: string | null;
  tiktokUrl: string | null;
  kickUrl: string | null;
  avatarUrl: string | null;
  avatarSourceUrl: string | null;
  avatarCropData: CropData | null;
  bannerUrl: string | null;
  bannerSourceUrl: string | null;
  bannerCropData: CropData | null;
};

export const roleConfig: Record<
  string,
  { label: string; color: "brand" | "purple" | "blue" | "gray" }
> = {
  owner: { label: "Owner", color: "brand" },
  admin: { label: "Admin", color: "purple" },
  moderator: { label: "Mod", color: "blue" },
  member: { label: "Member", color: "gray" },
};
